/**
 * A type that is specifically for minimizing the object being passed down to the content stream filter registrar
 * All validation will be handled by the content stream registrar. This is a very basic POJO
 *
 * @param {object} options - SEE BELOW
 * @param {string} type - The type of the filter value
 * @param {string} value - The filter value
 */
export class RefinementFilter {
    constructor({ type, value }) {
        this.type = type;
        this.value = value;

        Object.freeze(this);
    }
}